import _ from 'lodash';
import { memo, useCallback } from 'react';
import useCases from 'v2/modules/withRunForm/hooks/useCases/index';
import Case from './Case/index';
import { referenceTracker } from 'v3/quantConfig/reference/referenceTracker';
import { REFERENCE_LIST } from 'v2/common/constants';
import ParallelCase from './Case/ParallelCase';
import AddCase from './Case/AddCase';

const propTypes = {};
const defaultProps = {};

const webMaxCases = 7;

const Cases = () => {
  const {
    cases,
    onAddCase,
    onDeleteCase,
    activeCaseIndex,
    onChangeActiveCaseIndex,
    isMaximumCasesExceeded,
    isShowAddCaseHoverMessage,
    isSimpleMode,
    onCloneCase,
    errorConfigs,
    errorMessage,
    isHiddenSignal,
    onChangeSelectedCases,
    parallelCasesOptions,
    selectedParallelCases,
  } = useCases();
  const isAddIconRender = cases.length >= webMaxCases;
  const isPrivilegedUser = _.get(window, 'isPrivilegedUser', false);

  const renderAddCaseButton = (
    <button
      className="btn add-cases-btn btn-primary d-flex align-items-center"
      type="button"
      disabled={isMaximumCasesExceeded}
      onClick={onAddCase}
    >
      {isAddIconRender ? (
        <i className="material-icons-outlined">add</i>
      ) : (
        <>
          <i className="material-icons-outlined">add</i>
          <span className="ml-1">Add Case</span>
        </>
      )}
    </button>
  );

  const handleDeleteCase = useCallback(
    (caseIdx) => {
      const caseEntity = {
        type: REFERENCE_LIST.case,
        index: caseIdx,
        details: cases[caseIdx],
      };
      referenceTracker.performDeleteOrShowWarning(caseEntity, () => {
        // TODO: handle better way to change active case index after delete
        if (onDeleteCase(caseIdx)) setTimeout(() => onChangeActiveCaseIndex(cases.length - 2), 100);
      });
    },
    [cases, onDeleteCase]
  );

  const renderCaseIcon = useCallback(
    (idx) => {
      return (
        <div className="d-flex flex-row align-items-center actions-btn">
          <i className="fa-regular fa-copy" onClick={() => onCloneCase(idx)}></i>
          {cases?.length !== 1 && (
            <i className="close-icon fa-light fa-xmark" onClick={() => handleDeleteCase(idx)}></i>
          )}
        </div>
      );
    },
    [cases.length, onDeleteCase, onChangeActiveCaseIndex, onCloneCase]
  );

  const renderContentCase = useCallback(
    (caseConfig, idx) => {
      return (
        <span
          className={`${idx === activeCaseIndex ? '' : 'hidden-for-future hidden-bottom-border'}`}
          key={idx}
        >
          <Case
            caseConfig={caseConfig}
            caseIndex={idx}
            errorMessage={errorMessage}
            isHiddenSignal={isHiddenSignal}
            isSimpleMode={isSimpleMode}
            errorConfigs={errorConfigs}
          />
        </span>
      );
    },
    [isSimpleMode, activeCaseIndex, errorMessage, isHiddenSignal, errorConfigs]
  );
  return (
    <div className="cases-wrap">
      <div className="tab-content">
        <ParallelCase
          parallelCasesOptions={parallelCasesOptions}
          selectedItem={selectedParallelCases}
          onSelectItem={onChangeSelectedCases}
          isDisabled={!isPrivilegedUser}
        />
        <AddCase
          renderAddCaseButton={renderAddCaseButton}
          renderCaseIcon={renderCaseIcon}
          handleDeleteCase={handleDeleteCase}
          onCloneCase={onCloneCase}
          isDisabled={!isPrivilegedUser}
          isShowAddCaseHoverMessage={isShowAddCaseHoverMessage}
          cases={cases}
          activeCaseIndex={activeCaseIndex}
          onChangeActiveCaseIndex={onChangeActiveCaseIndex}
          isMaximumCasesExceeded={isMaximumCasesExceeded}
          onAddCase={onAddCase}
        >
          {_.map(cases, renderContentCase)}
        </AddCase>
      </div>
    </div>
  );
};

Cases.propTypes = propTypes;
Cases.defaultProps = defaultProps;

export default memo(Cases);
